// extracted by mini-css-extract-plugin
module.exports = {"SuccessModalContent_ButtonContainer":"styles_SuccessModalContent_ButtonContainer__2A6F-","SuccessModalContent_Button":"styles_SuccessModalContent_Button__LSytD"};